/*
	STATE
*/
//------------------------------------------------------------
// IMPORTS
//------------------------------------------------------------

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

//------------------------------------------------------------
// USER STATE
// * user has ONE game account per REAL EMAIL ADDRESS
// * user data resets with every NEW GAME
// * user data could be used for LEADERBOARDS (?)
// * user data persists even when SYSTEM is DESTROYED
// * user data can carry over into NEW EPISODES
// * NPCS share the SAME user data SCHEMA
// * an in-game CHARACTER CREATOR would PRE-FILL most DATA
//------------------------------------------------------------

const state = {
	email: null,
	username: null,
	firstName: null,
	lastName: null,
	level: 1,
	loggedIn: false,
	avatar: null,
	playSessions: 0,
	// cash: 40, // across all bank accounts
	// karma: 249, // Neutral
};

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	namespaced: true,
    state,
    mutations,
    actions,
    getters
};